import { createFileRoute } from '@tanstack/react-router';
import { lazy } from 'react';
import { FeatureFlag, TextKey } from '@mews-commander/enums';
import { MewsTeam, RouteType } from '@mews/enums';

const LazyFinanceManagerBookingsReport = lazy(
    async () => import(/* webpackChunkName: "financeReports" */ '@mews-commander/modules/src/modules/financeReports')
);

const Component = () => <LazyFinanceManagerBookingsReport workspaceId={Route.useParams().workspaceId} />;

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Finance/ManagerReport/Index/$workspaceId')({
    beforeLoad: ({ context: { checkFeatureFlag, checkPrivilege } }) => {
        checkFeatureFlag(FeatureFlag.managerReportEnabled);
        checkPrivilege('viewSensitiveReports');
    },
    component: Component,
    staticData: {
        owner: MewsTeam.Analytics,
        type: RouteType.Frontend,
        title: TextKey.ManagerReport,
    },
});
